import React, { useEffect } from "react";
import Grow from "@material-ui/core/Grow";
import {
  selectOverlay,
  selectInventoryAttribute,
} from "../../store/overlay/OverlaySelectors";
import { useSelector, useDispatch } from "react-redux";
import {
  selectVariantOptionLabels,
} from "../../store/product/ProductSelectors";
import { updateSelectedInventoryAttribute } from "../../store/overlay/OverlayActions";
import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { useIntl } from "react-intl";
import { OVERLAY_TABS } from "../../utils/Constants";
import DropdownMenu from "../common/DropdownMenu";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    select: {
      width: "80px",
      fontSize: "12px",
      position: "absolute",
      top: "0px",
      left: "18px",
      "& .MuiSelect-icon": {
        fontSize: 18,
        top: "calc(50% - 9px)",
      },
    },
    auxiliaryLinePath: {
      width: "5px",
      height: "15px",
      position: "absolute",
      borderLeft: `1px solid ${theme.palette.grey[400]}`,
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      left: "8px",
    },
    selectContainer: {
      position: "absolute",
      display: "block",
      marginTop: theme.spacing(1),
    },
    menuItemRoot: {
      fontSize: 12,
    },
  }),
);

const InventoryOverlayLabel = () => {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const overlay = useSelector(selectOverlay);
  const SKUAttributes = useSelector(selectVariantOptionLabels);
  const selectedInventoryAttribute = useSelector(selectInventoryAttribute);

  const handleInventoryAttributeChange = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    const attribute = event.target.value as string;
    dispatch(updateSelectedInventoryAttribute(attribute));
  };

  // When the overlay opens, default to the first available attribute so
  // the dropdown has a non-empty selection. Re-runs if the attribute set
  // changes (e.g. variants land later from the prefetch).
  useEffect(() => {
    if (
      overlay === OVERLAY_TABS.INVENTORY_OVERLAY &&
      SKUAttributes.length > 0 &&
      !selectedInventoryAttribute
    ) {
      dispatch(updateSelectedInventoryAttribute(SKUAttributes[0]));
    }
  }, [overlay, SKUAttributes, selectedInventoryAttribute, dispatch]);

  return (
    <>
      {intl.formatMessage({
        id: "overlayTabs.inventoryLabel",
        defaultMessage: "Inventory",
      })}
      <Grow
        in={overlay === OVERLAY_TABS.INVENTORY_OVERLAY}
        style={{ transformOrigin: "0 0 0" }}
        timeout={1000}
      >
        <div className={classes.selectContainer}>
          <div className={classes.auxiliaryLinePath} />
          <DropdownMenu
            menuId="InventoryOverlayLabel"
            classes={classes}
            value={selectedInventoryAttribute}
            changeHandler={handleInventoryAttributeChange}
            SKUAttributes={SKUAttributes}
          />
        </div>
      </Grow>
    </>
  );
};

export default React.memo(InventoryOverlayLabel);
